import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';
import { AuthGuard } from 'src/auth/guard';

import TradeTxPage from 'src/pages/overview/__trade-tx/trade-tx';
import ReportPage from 'src/pages/overview/report/report';
import GoldPricePage from 'src/pages/overview/gold-price/gold-price';

import RedeemPage from 'src/pages/overview/redeem/redeem';
import PositionPage from 'src/pages/overview/position/position';
import DepositPage from 'src/pages/overview/deposit/deposit';
import TopupDepositPage from 'src/pages/overview/topup-deposit/topup-deposit';
import TopupWithdrawPage from 'src/pages/overview/topup-withdraw/topup-withdraw';
import ExpiringTxPage from 'src/pages/overview/expiring-tx/expiring-tx';

export const overviewRoutes = [
  {
    path: 'overview',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TradeTxPage />, index: true },
      // { path: 'trade-tx', element: <TradeTxPage /> },
      { path: 'report', element: <ReportPage /> },
      { path: 'gold-price', element: <GoldPricePage /> },
      { path: 'redeem', element: <RedeemPage /> },
      { path: 'position', element: <PositionPage /> },
      { path: 'deposit', element: <DepositPage /> },
      { path: 'topup-deposit', element: <TopupDepositPage /> },
      { path: 'topup-withdraw', element: <TopupWithdrawPage /> },
      // { path: 'topup-withdraw/:id/detail', element: <TopupWithdrawDetailPage /> },
      // { path: 'gold-withdraw', element: <GoldWithdrawPage /> },
      // { path: 'gold-withdraw/:id/detail', element: <GoldWithdrawDetailPage /> },
      // { path: 'credit-loan', element: <CreditLoanPage /> },
      // { path: 'credit-loan/create', element: <CreditLoanCreatePage /> },
      // { path: 'credit-loan/:id/detail', element: <CreditLoanDetailPage /> },
      { path: 'expiring-tx', element: <ExpiringTxPage /> },
    ],
  },
];
